import { render, staticRenderFns } from "./live-logout.vue?vue&type=template&id=47f10a0c&scoped=true"
import script from "./live-logout.vue?vue&type=script&lang=js"
export * from "./live-logout.vue?vue&type=script&lang=js"
import style0 from "./live-logout.vue?vue&type=style&index=0&id=47f10a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f10a0c",
  null
  
)

export default component.exports